import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { GlasgowComaScaleAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-glasgow-coma-scale-slot',
    templateUrl: './glasgow-coma-scale-slot.component.html',
    styleUrl: './glasgow-coma-scale-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GlasgowComaScaleSlotComponent implements SheetSlotComponentBase {

	action!: GlasgowComaScaleAction;
	value!: string | null;

	@Input('action') set updateAction(action: GlasgowComaScaleAction | null) {
		this.action = action as GlasgowComaScaleAction;
		this.value = this.action.totalScore?.toString() ?? null;
	}

	constructor() {
	}
}